import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.pipe';
import { NoteTypePipe } from './note-type.pipe';
import { GetValuesPipe } from "./get-values.pipe";
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SystemPermissionPipe } from './system-permission.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        SearchPipe,
        NoteTypePipe,
        GetValuesPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        SystemPermissionPipe
    ],
    exports: [
        SearchPipe,
        NoteTypePipe,
        GetValuesPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        SystemPermissionPipe
    ]
})
export class PipesModule { }
